// API Configuration
export const API_BASE_URL = import.meta.env.PROD 
  ? 'https://dicomity.com.ar'  // Producción
  : 'http://localhost:9000';   // Desarrollo

// API Endpoints
export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/api/auth/login/',
  LOGOUT: '/api/auth/logout/',
  USER_INFO: '/api/auth/user/',
  REGISTER: '/api/auth/register/',
  
  // Clients
  CLIENTS: '/licenses/api/clients/',
  CLIENT_DETAIL: (id) => `/licenses/api/clients/${id}/`,
  
  // Software
  SOFTWARE: '/licenses/api/software/',
  SOFTWARE_REGISTER: '/licenses/api/software/register/',
  SOFTWARE_DETAIL: (id) => `/licenses/api/software/${id}/`,
  
  // Licenses
  LICENSES: '/licenses/api/licenses/',
  LICENSE_DETAIL: (id) => `/licenses/api/licenses/${id}/`,
  /** Liberar un cupo: elimina el registro de instalación (equipo) de esa licencia */
  LICENSE_RELEASE_INSTALLATION: (licenseId, installationId) =>
    `/licenses/api/licenses/${licenseId}/installations/${installationId}/`,
  LICENSE_VALIDATE: '/licenses/api/license/validate/',
  LICENSE_STATUS: (key) => `/licenses/api/license/${key}/status/`,
  LICENSE_GENERATE: '/licenses/api/license/generate/',
  
  // License Types
  LICENSE_TYPES: '/licenses/api/license-types/',
  LICENSE_TYPE_DETAIL: (id) => `/licenses/api/license-types/${id}/`,
  
  // Installations
  INSTALLATIONS: '/licenses/api/installations/',
  INSTALLATION_HEARTBEAT: '/licenses/api/installation/heartbeat/',
  
  // Statistics
  STATISTICS: '/licenses/api/statistics/',
  HEALTH_CHECK: '/licenses/api/health/',
};

// Client Types
export const CLIENT_TYPES = [
  { value: 'individual', label: 'Individual' },
  { value: 'small_business', label: 'Pequeña Empresa' },
  { value: 'medium_business', label: 'Empresa Mediana' },
  { value: 'large_business', label: 'Gran Empresa' },
  { value: 'enterprise', label: 'Empresa' },
];

// Client Status
export const CLIENT_STATUS = [
  { value: 'active', label: 'Activo' },
  { value: 'inactive', label: 'Inactivo' },
  { value: 'suspended', label: 'Suspendido' },
  { value: 'pending', label: 'Pendiente' },
];

// License Type Options - Now loaded dynamically from backend
export const LICENSE_TYPE_OPTIONS = [];

// License Status
export const LICENSE_STATUS = [
  { value: 'active', label: 'Activa' },
  { value: 'expired', label: 'Expirada' },
  { value: 'suspended', label: 'Suspendida' },
  { value: 'cancelled', label: 'Cancelada' },
];

// Validation Results (códigos de error de /licenses/api/license/validate/)
export const VALIDATION_RESULTS = [
  { value: 'success', label: 'Exitosa' },
  { value: 'failed', label: 'Fallida' },
  { value: 'expired', label: 'Expirada' },
  { value: 'suspended', label: 'Suspendida' },
  { value: 'limit_exceeded', label: 'Límite excedido' },
  { value: 'MAC_REGISTERED_TO_ANOTHER_LICENSE', label: 'MAC en otra licencia' },
  { value: 'SOFTWARE_INACTIVE', label: 'Software inactivo' },
  { value: 'INSTALLATION_ID_REGISTERED_TO_ANOTHER_LICENSE', label: 'installation_id en otra licencia' },
  { value: 'INSTALLATION_ID_MAC_MISMATCH', label: 'MAC no coincide con installation_id' },
  {
    value: 'INSTALLATION_MAC_CONFLICT',
    label: 'Dispositivo asociado a otra instalación',
  },
];

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
};

// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'license_manager_token',
  REFRESH_TOKEN: 'license_manager_refresh_token',
  USER: 'license_manager_user',
  THEME: 'license_manager_theme',
};

// Routes
export const ROUTES = {
  // Marketing routes
  HOME: '/',
  PRODUCTS: '/products',
  DICOMFILES: '/dicomfiles',
  DICOMCAPTURE: '/dicomcapture',
  DOCUMENTATION: '/documentation',
  CONTACT: '/contact',
  
  // Auth routes
  LOGIN: '/login',
  
  // App routes (protected)
  APP_HOME: '/app',
  DASHBOARD: '/app/dashboard',
  CLIENTS: '/app/clients',
  CLIENT_DETAIL: (id) => `/app/clients/${id}`,
  LICENSES: '/app/licenses',
  LICENSE_DETAIL: (id) => `/app/licenses/${id}`,
  LICENSE_TYPES: '/app/license-types',
  SOFTWARE: '/app/software',
  SOFTWARE_DETAIL: (id) => `/app/software/${id}`,
  REPORTS: '/app/reports',
  SETTINGS: '/app/settings',
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Error de conexión. Verifica tu conexión a internet.',
  UNAUTHORIZED: 'No tienes permisos para realizar esta acción.',
  FORBIDDEN: 'Acceso denegado.',
  NOT_FOUND: 'Recurso no encontrado.',
  VALIDATION_ERROR: 'Por favor, verifica los datos ingresados.',
  SERVER_ERROR: 'Error interno del servidor. Intenta nuevamente.',
  UNKNOWN_ERROR: 'Ha ocurrido un error inesperado.',
};

// Success Messages
export const SUCCESS_MESSAGES = {
  CLIENT_CREATED: 'Cliente creado exitosamente.',
  CLIENT_UPDATED: 'Cliente actualizado exitosamente.',
  CLIENT_DELETED: 'Cliente eliminado exitosamente.',
  LICENSE_CREATED: 'Licencia creada exitosamente.',
  LICENSE_UPDATED: 'Licencia actualizada exitosamente.',
  LICENSE_DELETED: 'Licencia eliminada exitosamente.',
  LICENSE_TYPE_CREATED: 'Tipo de licencia creado exitosamente.',
  LICENSE_TYPE_UPDATED: 'Tipo de licencia actualizado exitosamente.',
  LICENSE_TYPE_DELETED: 'Tipo de licencia eliminado exitosamente.',
  SOFTWARE_CREATED: 'Software registrado exitosamente.',
  SOFTWARE_UPDATED: 'Software actualizado exitosamente.',
  SOFTWARE_DELETED: 'Software eliminado exitosamente.',
};

// Chart Colors
export const CHART_COLORS = {
  PRIMARY: '#3b82f6',
  SUCCESS: '#22c55e',
  WARNING: '#f59e0b',
  DANGER: '#ef4444',
  INFO: '#06b6d4',
  PURPLE: '#8b5cf6',
  PINK: '#ec4899',
  INDIGO: '#6366f1',
  TEAL: '#14b8a6',
  ORANGE: '#f97316',
};

// Date Formats
export const DATE_FORMATS = {
  SHORT: 'dd/MM/yyyy',
  LONG: 'dd MMMM yyyy',
  DATETIME: 'dd/MM/yyyy HH:mm',
  TIME: 'HH:mm',
};

// File Upload
export const FILE_UPLOAD = {
  MAX_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'],
};
